import { CALL_API } from '../../../middlewares/api';

import {
    REQUEST_LOGIN,
    SUCCESS_LOGIN,
    SUCCESS_DARTY_LOGIN,
    FAILURE_LOGIN,
    RESET_LOGIN_FORM
} from './constants';

import { redirectToSsoUrl } from '../utils';
import { updateInfos } from '../../account/actions';
import { fetchEbonPartners } from '../../ebon/actions';
import { forceFetchPartners } from '../../partner/actions';
import { forceFetchBilletteriePartners } from '../../billetterie/actions';

import { makeActionCreator } from '../../../utils/actionsUtils';
import { extractSsoToken, extractSsoProvider } from '../../../utils/ssoUtil';

export const resetForm = makeActionCreator(RESET_LOGIN_FORM);

/**
 * Échange le token SSO (?tk=xxx&provider=...) contre le JWT de session via /auth/login.
 * @param callback      appelé avec la réponse (AuthDto) en succès
 * @param errorCallback appelé (response, dispatch) si l'échange échoue : sur 401 le middleware
 *                      a déjà déconnecté l'utilisateur, il reste à lui donner un retour
 */
export const loginUserWithToken = (creds, callback, errorCallback) => {
    return {
        [CALL_API]: {
            endpoint: '/auth/login',
            types: [REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN],
            body: creds,
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload.user));
                dispatch(forceFetchPartners());
                dispatch(fetchEbonPartners());
                dispatch(forceFetchBilletteriePartners());
                if (callback) {
                    // la réponse (AuthDto) porte le flag limited : les consommateurs
                    // en ont besoin pour décider de la redirection post-login
                    callback(response);
                }
            },
            errorCallback
        }
    };
};

/**
 * Consomme la réponse de succès du back (SsoDecodeTokenDto) : l'URL renvoyée contient
 * le token SSO et l'origine d'authentification (?tk=xxx&provider=fnac|darty) que l'on
 * échange contre le JWT de session via /auth/login, comme au retour des SSO Fnac et Darty
 * (RouterComponent).
 */
export const handleSsoAuthSuccess = (response, dispatch, callback) => {
    const { url } = response.payload;
    const token = extractSsoToken(url);
    if (token) {
        dispatch(loginUserWithToken({ token, provider: extractSsoProvider(url) }, callback));
    } else {
        redirectToSsoUrl(response, dispatch);
    }
};

export const loginUserWithCredentials = (creds, callback) => {
    return {
        [CALL_API]: {
            endpoint: '/darty/login',
            types: [REQUEST_LOGIN, SUCCESS_DARTY_LOGIN, FAILURE_LOGIN],
            body: creds,
            successCallback: (response, dispatch) =>
                handleSsoAuthSuccess(response, dispatch, callback),
            // en erreur le back renvoie l'URL de redirection (/connexion?error=X ou
            // /rejoignez-le-programme?error=1), on y emmène l'utilisateur
            errorCallback: redirectToSsoUrl
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/authentication/login/actions.js